/* Block - Accordion.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-accordion.scss";
import Accordion from '../../js/component/_accordion.js';

Accordion.toggle();
